<template>
  <div>
    <b-row>
      <b-col
        xl="3"
        lg="2"
        md="0"
        sm="0"
      />
      <b-col
        xl="6"
        lg="8"
        md="12"
        sm="12"
      >
        <video
          id="video"
          style="width:100%; height:auto; flex-direction: row;"
          muted
          autoplay
          playsinline
        />
      </b-col>
      <b-col
        xl="3"
        lg="2"
        md="0"
        sm="0"
      />
    </b-row>
  </div>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import Hls from 'hls.js'

export default {
  components: {
    BRow,
    BCol,
  },
  data() {
    return {
      stream: 'https://stream.firsttech.co.th/live/nakornnont.stream/playlist.m3u8',
      option: {
        overNative: true,
        autoplay: true,
        controls: false,
        muted: true,
        playsinline: true,
        techOrder: ['html5'],
        sourceOrder: true,
        width: 1000,
        height: 500,
        responsive: true,
        html5: {
          vhs: {
            withCredentials: false,
            overrideNative: true,
            nativeAudioTracks: false,
            nativeVideoTracks: false,
            smoothQualityChange: false,
          },
        },
        sources: [
          {
            withCredentials: false,
            type: 'application/x-mpegURL',
            src: 'https://stream.firsttech.co.th/live/nakornnont.stream/playlist.m3u8',
          },
        ],
      },
    }
  },
  mounted() {
    this.streamLive()
    this.interval = setInterval(() => {
      this.streamLive()
    }, 300000)
  },
  methods: {
    // streamLive() {
    //   setTimeout(() => {
    //     const hls = new Hls({
    //       lowLatencyMode: true,
    //       autoreconnect: true,
    //     })
    //     const video = document.querySelector('#video')
    //     hls.loadSource(this.stream)
    //     hls.attachMedia(video)
    //     hls.on(Hls.Events.MANIFEST_PARSED, () => {
    //       video.play()
    //       console.log(video)
    //     })
    //     hls.on(Hls.Events.ERROR, () => {
    //       video.play()
    //       console.log(video)
    //     })
    //   }, 500)
    // },
    streamLive() {
      this.hls = new Hls({
        lowLatencyMode: true,
        autoreconnect: true,
      })
      const video = document.querySelector('#video')
      const videoSrc = this.stream
      if (video.canPlayType('application/vnd.apple.mpegurl')) {
        video.src = videoSrc
      } else if (Hls.isSupported()) {
        this.hls.loadSource(videoSrc)
        this.hls.attachMedia(video)
        this.hls.on(Hls.Events.MANIFEST_PARSED, () => {
          video.play()
        })
      }
    },
  },
}
</script>

<style>
.video-js{
  background-color:rgba(255,0,0,0)
}
#vjs_video_3_html5_api{
  width: 50%;
}
</style>
